import { BadgeEnamel, BadgeLabel, BadgePaletteKey } from './types.js'

interface BadgePalette extends BadgeEnamel {
    label: BadgeLabel
}

/** Deep enamel pairs from badges.config.js (ring = outer band, field = inner). */
export const BADGE_PALETTES: Record<BadgePaletteKey, BadgePalette> = {
    yellow: { ring: '#F6C03A', field: '#A35A05', label: { et: 'Kollane', en: 'Yellow' } },
    purple: { ring: '#A580E0', field: '#472983', label: { et: 'Lilla', en: 'Purple' } },
    blue: { ring: '#80B8F0', field: '#1C5496', label: { et: 'Sinine', en: 'Blue' } },
    mint: { ring: '#4FD0AA', field: '#0A6C55', label: { et: 'Mint', en: 'Mint' } },
    coral: { ring: '#F5A98F', field: '#A33E28', label: { et: 'Korall', en: 'Coral' } },
    pink: { ring: '#F595AC', field: '#9E284E', label: { et: 'Roosa', en: 'Pink' } },
    // Company colours for anniversary badges (Nele, 15.10.2026): brand tone on the ring, deeper field.
    nope: { ring: '#C1A5FF', field: '#6B3FD4', label: { et: 'NOPE lilla', en: 'NOPE purple' } },
    play: {
        ring: '#8FE6D3',
        field: '#008F75',
        label: { et: 'PLAY akvamariin', en: 'PLAY aquamarine' },
    },
}

/** Icy enamel used under the crystal of special (awarded) badges, regardless of category. */
export const ICE_ENAMEL: BadgeEnamel = { ring: '#EEF7FF', field: '#CDE7FB' }
